import { useTranslation } from 'next-i18next'

import { Link } from '~/components/Link'
import { FamilyAccountsColorClasses } from '~/familyAccount/familyAccounts.constants'
import useCurrentFamily from '~/familyAccount/hooks/useCurrentFamily'
import { FAMILY_PROFILE_COLORS } from '~/familyAccount/types/familyAccounts.types'
import useCurrentUser from '~/hooks/useCurrentUser'
import AvatarImage from '~/menu/components/AvatarImage'
import useMenuSubscriptionState from '~/menu/hooks/useMenuSubscriptionState'
import { useAppDispatch } from '~/redux/hooks'
import { closeMenu } from '~/redux/slices/menu'
import ROUTES from '~/shared/constants/routes.const'

export default function SwitchProfile(): React.ReactElement {
  const { t } = useTranslation('menu')
  const user = useCurrentUser()
  const { familyUserData } = useCurrentFamily()
  const { showFamilyFeatures } = useMenuSubscriptionState()
  const dispatch = useAppDispatch()
  const hasFamilyMembers = familyUserData && familyUserData.length > 1
  // showFamilyFeatures already guarantees a family, so the admin panel has something to render
  const destination = hasFamilyMembers ? ROUTES.FAMILY_SWITCH_PROFILE : ROUTES.FAMILY_ADMIN_PANEL
  const profile = familyUserData?.filter((familyProfile) => familyProfile.userId === user?.id)[0] || {
    profileColor: FAMILY_PROFILE_COLORS.BLUE,
  }

  const onSwitchClick = (): void => {
    dispatch(closeMenu())
  }

  if (!user || !showFamilyFeatures) {
    return <></>
  }

  return (
    <Link
      className="flex w-full cursor-pointer items-center gap-3.5 rounded-2 px-2.5 py-2 duration-300 hover:bg-purple-darker"
      data-test-id="menu-switch-profile"
      onClick={onSwitchClick}
      to={destination}
    >
      <span className="flex w-7 shrink-0 items-center justify-center">
        <span className={`h-7 w-7 overflow-hidden rounded-full ${FamilyAccountsColorClasses[profile.profileColor]}`}>
          {/* AvatarImage's crop offsets are calibrated for the old 36px circle — render at 36px and scale down to 28px */}
          <span className="block h-9 w-9 origin-top-left scale-80">
            <AvatarImage />
          </span>
        </span>
      </span>
      <span className="flex flex-col items-start">
        <p className="max-w-32 truncate text-sm font-medium leading-5.5 text-white">{user.nickname}</p>
        <p className="text-xs leading-5.5 text-white">{hasFamilyMembers ? t('switchProfile') : t('createFamily')}</p>
      </span>
    </Link>
  )
}
